(function () {
  function bind(root) {
    if (!root || root.dataset.dlBound === 'true') return;
    root.dataset.dlBound = 'true';

    var row = root.querySelector('[data-dl-acc-row]');
    var prev = root.querySelector('[data-dl-acc-prev]');
    var next = root.querySelector('[data-dl-acc-next]');
    if (!row) return;

    function step() {
      var card = row.querySelector('.dl-acc-card');
      var gap = parseFloat(getComputedStyle(row).gap) || 18;
      return (card ? card.getBoundingClientRect().width : 210) + gap;
    }

    function go(dir) {
      row.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  function init() {
    document.querySelectorAll('[data-dl-page]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-dl-page]');
    if (root) {
      root.dataset.dlBound = 'false';
      bind(root);
    }
  });
})();
